import "./_tooltip.scss";

import classNames from "classnames";
import MaterialTooltip, {
  TooltipProps as MaterialTooltipProps
} from "@mui/material/Tooltip";
import {Fragment} from "react";

export interface TooltipProps {
  id?: string;
  children: React.ReactNode;
  content: React.ReactNode;
  containerId?: string;
  customClassName?: string;
  isDisabled?: boolean;
  placement?: MaterialTooltipProps["placement"];
  hasArrow?: boolean;
  type?: "default" | "no-underline";
  controlledTooltip?: {
    open: MaterialTooltipProps["open"];
    onOpen?: MaterialTooltipProps["onOpen"];
    onClose?: MaterialTooltipProps["onClose"];
  };
}

function Tooltip({
  id,
  containerId,
  customClassName,
  content,
  children,
  isDisabled,
  placement,
  hasArrow = true,
  type = "default",
  controlledTooltip
}: TooltipProps) {
  const containerClassName = classNames(
    "tooltip-container",
    customClassName,
    `tooltip-container--${type}`
  );

  return (
    <div id={containerId} className={containerClassName}>
      {isDisabled ? (
        <div className={"tooltip-trigger"}>{children}</div>
      ) : (
        <MaterialTooltip
          id={id}
          title={<Fragment>{content}</Fragment>}
          arrow={hasArrow}
          placement={placement}
          disableFocusListener={true}
          enterTouchDelay={100}
          disableInteractive={Boolean(controlledTooltip)}
          open={controlledTooltip?.open}
          onOpen={controlledTooltip?.onOpen}
          onClose={controlledTooltip?.onClose}>
          <div className={"tooltip-trigger"}>{children}</div>
        </MaterialTooltip>
      )}
    </div>
  );
}

export default Tooltip;
